import React from 'react'
import {Lang} from 'yougile-lang'
import {Button, LinkButton} from '@components/common/button/button'
import {Dropdown} from '@components/common/dropdown/dropdown'
import {useBoolean} from '@containers/hooks'

interface Props {
  deleteCurrent: () => void
}

export const FilterDeletion = ({deleteCurrent}: Props) => {
  const deletion = useBoolean(false)

  return (
    <Dropdown
      animation={false}
      placement={'top'}
      duration={0}
      visible={deletion.value}
      onVisibleChange={() => deletion.setValue(false)}
      content={
        <div className="text-main-old bg-main-old">
          <div className="m-8 mb-0 text-12">
            <span className="whitespace-nowrap">
              {Lang.msg.statsTimeline.removeThisFilter}
            </span>
            <br />
            <span className="whitespace-nowrap">
              {Lang.msg.statsTimeline.recoveryIsImpossible}
            </span>
          </div>
          <div className="flex m-8 justify-evenly">
            <Button $small $bgClassName="bg-error-old" onClick={deleteCurrent}>
              {Lang.msg.statsTimeline.yesDelete}
            </Button>
            <Button $small onClick={deletion.turnOff}>
              {Lang.msg.statsTimeline.cancel}
            </Button>
          </div>
        </div>
      }
    >
      <LinkButton
        $small
        $textClassName="text-error-old"
        onClick={deletion.turnOn}
      >
        {Lang.msg.statsTimeline.removeFilter}
      </LinkButton>
    </Dropdown>
  )
}
